import "core-js/modules/es.array.push.js";
export default {
  name: "ShopRightWrap",
  props: {
    list: {
      type: Array,
      default: () => []
    },
    scrollTop: {
      type: Number,
      default: 0
    },
    isFinish: {
      type: Boolean,
      default: true
    },
    scrolling: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      scrollY: 0 // 滑动的y轴坐标
    };
  },
  watch: {
    isFinish: {
      handler(nVal) {
        return this.isFinish = nVal;
      },
      immediate: true
    }
  },
  created() {
    this.$nextTick(() => {
      this.initIntersectionObserver();
    });
  },
  methods: {
    initIntersectionObserver() {
      let ob = new IntersectionObserver(e => {
        if (this.scrolling) {
          return;
        }
        if (e[0].isIntersecting && !this.isFinish) {
          let inx = e[0].target.dataset.inx;
          if (!this.list[inx].list_finish) {
            this.$emit("loadMore", Number(inx));
          }
        }
      }, {
        root: this.$refs.listWrapRef
      });
      this.$refs.listRef.forEach(item => {
        ob.observe(item);
      });
    },
    isInventory(item) {
      let isInventory = false;
      item.skus.forEach(item2 => {
        if (Number(item2.stock) !== 0) {
          isInventory = true;
        }
      });
      return isInventory;
    },
    handleAddCart(itemGoods, indexFoods, indexGoods) {
      this.$emit("handleAddCart", itemGoods, indexFoods, indexGoods);
    },
    handleDetailsNum(type, obj, indexFoods, indexGoods) {
      this.$emit("handleDetailsNum", type, obj, indexFoods, indexGoods);
    },
    openSpecificationDialog(itemGoods, indexFoods, indexGoods) {
      this.$emit("openSpecificationDialog", itemGoods, indexFoods, indexGoods);
    },
    goodsScroll(e) {
      if (this.scrolling) {
        return;
      }
      this.scrollY = e.target.scrollTop;
      this.initRightBoxHeight();
    },
    // 计算每个小盒子高度
    initRightBoxHeight() {
      let itemArray = [];
      let top = 0;
      itemArray.push(top);
      // 获取右边所有子盒子高度集合
      let allList = this.$refs.listWrapRef.getElementsByClassName("list-box");
      // allList伪数组转化成真数组
      Array.prototype.slice.call(allList).forEach(li => {
        top += li.clientHeight; //获取所有li的每一个高度
        itemArray.push(top);
      });
      this.rightLiTops = itemArray;
      this.rightLiTops.forEach((item, index) => {
        if (item <= this.scrollY) {
          this.$emit("activeTypeScroll", index);
        }
      });
    }
  }
};